import throttle from 'lodash.throttle'
import { getPosition, viewport, heightInView } from '../helpers/helpers'
import { TimelineMax } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

export default class Story {
	constructor() {

		this.cover = document.querySelector('.stype__cover');
		this.content = document.querySelector('.stype__content');
		if (this.content) {
  		this.quotes = [...this.content.querySelectorAll('blockquote')];
  		this.paragraphs = [...this.content.querySelectorAll('.stype__container p')];
  		this.share = document.querySelector('.stype__share');
  		this.related = document.querySelector('.stype__related');
  		this.videos = [...this.content.querySelectorAll('.embed-container--inline')];
		}
		this.threshold = 250; // section needs to be at least [threshold]px in view to animate

		if (document.querySelector('img.alignleft') || document.querySelector('img.alignright')) {
			var al = document.querySelectorAll('img.alignleft');
			for (var i = 0; i < al.length; i++) {
				var f = document.createElement('figure');
				f.classList.add('alignleft');
				al[i].parentNode.insertBefore(f, al[i]);
				f.appendChild(al[i]);
			}
			var al = document.querySelectorAll('img.alignright');
			for (var i = 0; i < al.length; i++) {
				var f = document.createElement('figure');
				f.classList.add('alignright');
				al[i].parentNode.insertBefore(f, al[i]);
				f.appendChild(al[i]);
			}
		}

		this.init();
		this.events();
	}

	init() {
		if (this.cover) {
			this.coverAnim();
		}

		this.scrollHandle();
	}

	events() {
		this.scrollEventHandler = throttle(this.scrollHandle, 16).bind(this);
		window.addEventListener('scroll', this.scrollEventHandler);
		window.addEventListener('resize', this.scrollHandle.bind(this));
	}

	coverAnim() {
		const bg = this.cover.querySelector('.stype__cover__bg');
		const title = this.cover.querySelector('.stype__cover__title');
		const subtitle = this.cover.querySelector('.stype__cover__subtitle');

		let coverTl = new TimelineMax({
			delay: 0.3,
			onStart: () => {
				this.cover.classList.remove('waiting');
			}
		});

		coverTl
		.from(bg, 2, { ease: Power2.easeInOut, scale: 1.2, alpha: 0 })
		.from(title, 1, { ease: Power2.easeOut, alpha: 0, x: 20 }, 0.9)
		.from(subtitle, 1, { ease: Power2.easeOut, alpha: 0, x: -30 }, 1)
	}

	anim(el) {
		if (!el.classList.contains('animated')) {
			if (this.inView(el)) {
				el.classList.add('animated');
			}
		}
	}

	relatedAnim() {
		if (this.inView(this.related)) {
			this.relatedAnimted = true;

			const tiles = [...this.related.querySelectorAll('.stile')];

			let relatedTl = new TimelineMax({
				onStart: () => {
					this.related.classList.remove('waiting');
				}
			});

			relatedTl
			.staggerFrom(tiles, 1, { ease: Power2.easeOut, alpha: 0 }, 0.2);
		}
	}

	scrollHandle() {
		if (this.quotes) {
			this.quotes.forEach(quote => {
				this.anim(quote);
			});
		}

		if (this.paragraphs) {
			this.paragraphs.forEach(p => {
				this.anim(p);
			});
		}

		if (this.videos) {
			this.videos.forEach(v => {
				this.anim(v);
			});
		}

		if (this.share) {
			this.anim(this.share);
		}

		if (this.related && !this.relatedAnimted) {
			this.relatedAnim();
		}
	}

	inView(section) {
		return heightInView(section) >= Math.min(this.threshold, section.getBoundingClientRect().height);
	}

}
